export default class CanvasObject {
  x;
  y;
  size = 20;
  colour = "black";

  constructor(x, y, colour) {
    this.x = x;
    this.y = y;
    this.colour = colour;
  }

  setCoords(x, y) {
    this.x = x;
    this.y = y;
  }

  //TODO: need to ensure it is in boundaries and not in snake body
  respawn(context) {
    this.setCoords(
      Math.floor(Math.random() * (context.canvas.width - this.size)),
      Math.floor(Math.random() * (context.canvas.height - this.size))
    );
  }

  draw(context) {
    context.fillStyle = this.colour;
    context.fillRect(
      this.x - this.size / 2,
      this.y - this.size / 2,
      this.size,
      this.size
    );
  }
}
